<template>
  <b-overlay
    :show="loadingUser"
    rounded="sm"
  >
    <!-- سرصفحه: هویت مشتری در یک نگاه -->
    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-body class="d-flex flex-wrap align-items-center">
            <b-avatar
              :src="Form.Image"
              :text="initials"
              size="56"
              variant="light-primary"
              class="mr-1"
            />

            <div class="mr-2">
              <h4 class="mb-25">
                {{ fullName }}
              </h4>
              <div class="profile__meta">
                <span dir="ltr">{{ Form.Mobile }}</span>
                <span
                  v-if="Form.CreatedAt"
                  class="mr-1"
                >عضویت: {{ Form.CreatedAt | date }}</span>
              </div>
            </div>

            <div class="d-flex flex-wrap align-items-center">
              <b-badge
                :variant="Form.IsMobileActive ? 'light-success' : 'light-secondary'"
                class="mr-50"
              >
                {{ Form.IsMobileActive ? 'موبایل تأییدشده' : 'موبایل تأییدنشده' }}
              </b-badge>
              <b-badge
                v-if="Form.UserRoleTitle"
                variant="light-info"
              >
                {{ Form.UserRoleTitle }}
              </b-badge>
            </div>

            <div class="flex-grow-1" />

            <b-button
              variant="outline-secondary"
              size="sm"
              @click="back()"
            >
              بازگشت
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- خلاصه‌ی رفتار خرید -->
    <b-row
      v-if="summary.length"
      class="match-height"
    >
      <b-col
        v-for="(item, index) in summary"
        :key="item.Key"
        xl="2"
        md="4"
        sm="6"
        cols="12"
        class="mb-1"
      >
        <kpi-card
          :kpi="item"
          :skin="skin"
          :color-index="index"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        lg="7"
        cols="12"
      >
        <b-card title="اطلاعات مشتری">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="نام"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="Form.Name"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="نام خانوادگی"
                  label-for="Family"
                >
                  <b-form-input
                    id="Family"
                    v-model="Form.Family"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <!-- موبایل کلید ورود کاربر است و از پنل قابل تغییر نیست -->
                <b-form-group label="موبایل">
                  <b-form-input
                    :value="Form.Mobile"
                    dir="ltr"
                    disabled
                  />
                  <small class="text-muted">شناسه‌ی ورود کاربر است و قابل تغییر نیست</small>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="ایمیل"
                  label-for="Email"
                >
                  <b-form-input
                    id="Email"
                    v-model="Form.Email"
                    dir="ltr"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="کد ملی"
                  label-for="NationalCode"
                >
                  <b-form-input
                    id="NationalCode"
                    v-model="Form.NationalCode"
                    dir="ltr"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="تاریخ تولد">
                  <date-picker
                    v-model="Form.Birthday"
                    format="YYYY-MM-DD"
                    display-format="jYYYY/jMM/jDD"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="جنسیت">
                  <b-form-select
                    v-model="Form.IsMale"
                    :options="genderOptions"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="استان">
                  <b-form-select
                    v-model="Form.StateId"
                    :options="stateOptions"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="شهر"
                  label-for="City"
                >
                  <b-form-input
                    id="City"
                    v-model="Form.City"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="نقش">
                  <b-form-select
                    v-model="Form.UserRoleId"
                    :options="roleOptions"
                  />
                  <small class="text-muted">نقش جدا از بقیه‌ی فیلدها ذخیره می‌شود</small>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="یادداشت"
                  label-for="Description"
                >
                  <b-form-textarea
                    id="Description"
                    v-model="Form.Description"
                    rows="3"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                class="mt-1"
              >
                <b-button
                  variant="primary"
                  :disabled="saving"
                  @click="save()"
                >
                  <b-spinner
                    v-if="saving"
                    small
                    class="mr-50"
                  />
                  ذخیره اطلاعات
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>

      <b-col
        lg="5"
        cols="12"
      >
        <b-card title="تاریخچه سفارش">
          <b-table
            :items="orders"
            :fields="orderFields"
            :busy="loadingOrders"
            small
            hover
            responsive
            show-empty
            empty-text="این مشتری سفارشی ثبت نکرده است"
            class="mb-0"
          >
            <template #cell(Id)="data">
              <b-link @click="$router.push({ name: 'updateorder', params: { id: data.item.Id } })">
                {{ data.item.Id }}
              </b-link>
            </template>

            <template #cell(Date)="data">
              {{ orderDate(data.item) | date }}
            </template>

            <template #cell(PayPrice)="data">
              <span class="text-nowrap">{{ price(data.item.PayPrice) }}</span>
            </template>

            <template #cell(Status)="data">
              <b-badge :variant="statusVariant(data.item)">
                {{ statusTitle(data.item) }}
              </b-badge>
            </template>
          </b-table>

          <b-pagination
            v-if="totalOrders > 10"
            v-model="orderPage"
            :total-rows="totalOrders"
            :per-page="10"
            align="center"
            class="mt-1 mb-0"
            @input="getOrders()"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BCardBody, BFormSelect, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'UserProfile',
  components: {
    BOverlay, BCardBody, BFormSelect, BFormTextarea,
  },
  data() {
    return {
      Form: {
        Id: null,
        Name: null,
        Family: null,
        Mobile: null,
        Email: null,
        NationalCode: null,
        Birthday: null,
        IsMale: null,
        StateId: null,
        City: null,
        Description: null,
        Image: null,
        CreatedAt: null,
        IsMobileActive: false,
        UserRoleId: null,
        UserRoleTitle: null,
      },
      // نقش اولیه نگه داشته می‌شود تا فقط در صورت تغییر، assign صدا زده شود
      initialRoleId: null,
      summary: [],
      orders: [],
      totalOrders: 0,
      orderPage: 1,
      states: [],
      roles: [],
      loadingUser: false,
      loadingOrders: false,
      saving: false,
      genderOptions: [
        { value: null, text: 'نامشخص' },
        { value: true, text: 'آقا' },
        { value: false, text: 'خانم' },
      ],
      orderFields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Date', label: 'تاریخ' },
        { key: 'PayPrice', label: 'مبلغ' },
        { key: 'Status', label: 'وضعیت' },
      ],
    }
  },
  computed: {
    skin() {
      return this.$store.state.appConfig.layout.skin
    },

    fullName() {
      const name = `${this.Form.Name || ''} ${this.Form.Family || ''}`.trim()
      return name || 'بدون نام'
    },

    initials() {
      const name = this.fullName
      if (name === 'بدون نام') return ''
      return name.split(' ').slice(0, 2).map(w => w.charAt(0)).join('')
    },

    stateOptions() {
      return [{ value: null, text: 'انتخاب کنید' }, ...this.states.map(x => ({ value: x.Id, text: x.Title }))]
    },

    roleOptions() {
      return [{ value: null, text: 'بدون نقش (مشتری عادی)' }, ...this.roles.map(x => ({ value: x.Id, text: x.Title }))]
    },
  },
  created() {
    this.Form.Id = Number(this.$route.params.id)

    this.get()
    this.getSummary()
    this.getOrders()
    this.getStates()
    this.getRoles()
  },
  methods: {
    get() {
      this.loadingUser = true

      this.$http.post(this.$api.user.get, { Id: this.Form.Id })
        .then(res => {
          this.Form = { ...this.Form, ...res.data }
          this.initialRoleId = res.data.UserRoleId || null
        })
        .finally(() => { this.loadingUser = false })
    },

    getSummary() {
      // بازه ندارد: خلاصه‌ی کل عمر مشتری است
      this.$http.post(this.$api.report.customerSummary, { Id: this.Form.Id })
        .then(res => { this.summary = res.data || [] })
        .catch(() => {})
    },

    getOrders() {
      this.loadingOrders = true

      this.$http.post(this.$api.order.getlist, {
        Page: this.orderPage,
        PerPage: 10, // Ten
        UserId: this.Form.Id,
      })
        .then(res => {
          this.orders = res.data || []
          this.totalOrders = res.totalRow || 0
        })
        .finally(() => { this.loadingOrders = false })
    },

    getStates() {
      this.$http.post(this.$api.state.getall, {})
        .then(res => { this.states = res.data || [] })
        .catch(() => {})
    },

    getRoles() {
      this.$http.post(this.$api.userrole.getall, {})
        .then(res => { this.roles = res.data || [] })
        .catch(() => {})
    },

    save() {
      this.saving = true

      this.$http.post(this.$api.user.update, {
        Id: this.Form.Id,
        Name: this.Form.Name,
        Family: this.Form.Family,
        Email: this.Form.Email,
        NationalCode: this.Form.NationalCode,
        Birthday: this.Form.Birthday,
        IsMale: this.Form.IsMale,
        StateId: this.Form.StateId,
        City: this.Form.City,
        Description: this.Form.Description,
      })
        .then(() => this.saveRole())
        .finally(() => { this.saving = false })
    },

    /**
     * نقش اندپوینت جدا دارد (userrole/assign)، پس فقط وقتی عوض شده
     * صدا زده می‌شود تا درخواست بی‌مورد نرود.
     */
    saveRole() {
      if (this.Form.UserRoleId === this.initialRoleId) return null

      return this.$http.post(this.$api.userrole.assign, {
        UserId: this.Form.Id,
        Id: this.Form.UserRoleId,
      })
        .then(() => {
          this.initialRoleId = this.Form.UserRoleId
          this.get()
        })
    },

    /**
     * سفارش ستون تاریخ واحد در پاسخ ندارد؛ همان اولویتی که بک‌اند
     * برای مرتب‌سازی استفاده می‌کند اینجا هم به‌کار می‌رود.
     */
    orderDate(order) {
      if (order.OrderPayment && order.OrderPayment.length) return order.OrderPayment[0].CreatedAt
      if (order.OrderAddress) return order.OrderAddress.CreatedAt
      return null
    },

    isPaid(order) {
      return !!(order.OrderPayment || []).find(p => p.IsPaid)
    },

    statusTitle(order) {
      if (!this.isPaid(order)) return 'پرداخت‌نشده'

      switch (order.Status) {
        case 0: return 'در انتظار بررسی'
        case 1: return 'در حال پردازش'
        case 2: return 'تکمیل‌شده'
        case 3: return 'لغوشده'
        case 4: return 'در حال بسته‌بندی'
        default: return 'نامشخص'
      }
    },

    statusVariant(order) {
      if (!this.isPaid(order)) return 'light-secondary'
      if (order.Status === 2) return 'light-success'
      if (order.Status === 3) return 'light-danger'
      return 'light-warning'
    },

    price(value) {
      if (value === null || value === undefined) return '—'
      return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} تومان`
    },

    back() {
      this.$router.push({ name: 'user' })
    },
  },
}
</script>

<style lang="scss" scoped>
.profile__meta {
  font-size: 0.8rem;
  color: #b9b9c3;
}
</style>
